module.exports = __webpack_public_path__ + "img/cong.bd1d262c.jpeg";